export class MascaraDataUtil {
  private static mDateFormat = "dd/mm/yyyy";

  public static executeProgram() {}

  public static MascaraHora(evt, obj, seg) {
    if (obj.value.length == 8) return;
    else if (obj.value.length == 2 || (obj.value.length == 5 && seg))
      obj.value = obj.value + ":";
    this.MascaraInteiro(evt);
  }

  public static MascaraInteiro(evt) {
    var k = evt.keyCode;
    if ((k > 57 || k < 48) && k != 13) return;
  }

  public static MascaraData(evt, obj) {
    let lPos = null;
    var Sep = "";
    var acceptedKeys = "{104}{72}{84}{116}{102}{70}{117}{85}{112}{80}{108}{76}";
    var lValueInitial = obj.value.toUpperCase();

    if (lValueInitial.length > 0) {
      lValueInitial = lValueInitial.substring(0, 1);
    } else {
      lValueInitial = "";
    }

    if (obj.value.length == 10) {
      return;
    } else if (
      lValueInitial == "T" ||
      lValueInitial == "H" ||
      lValueInitial == "F" ||
      lValueInitial == "P" ||
      lValueInitial == "U" ||
      lValueInitial == "L"
    ) {
      if (
        obj.value.length == 1 &&
        evt.keyCode != 43 &&
        evt.keyCode != 45 &&
        evt.keyCode != 13
      ) {
        return;
      } else if (obj.value.length >= 2 && evt.keyCode != 13) {
        //Numeraï¿½ï¿½o
        this.MascaraInteiro(evt);
      } else if (
        evt.keyCode == 13 &&
        (obj.value.length == 1 || obj.value.length > 2)
      ) {
        //Confirma configuraï¿½ï¿½o
        this.executeProgram();
        return;
      }
    } else if (
      obj.value.length == 0 &&
      acceptedKeys.indexOf("{" + evt.keyCode + "}") >= 0
    ) {
      //Programaï¿½ï¿½o
      if (evt.keyCode > 100) {
        evt.keyCode = evt.keyCode - 32;
      }
    } else {
      lPos = this.mDateFormat.toLowerCase().indexOf("yyyy");
      if (lPos == 0) {
        if (obj.value.length == 4)
          obj.value = obj.value + this.mDateFormat.toLowerCase().charAt(4);
        else if (obj.value.length == 7)
          obj.value = obj.value + this.mDateFormat.toLowerCase().charAt(7);
      }
      if (lPos == 3) {
        if (obj.value.length == 2)
          obj.value = obj.value + this.mDateFormat.toLowerCase().charAt(2);
        else if (obj.value.length == 7)
          obj.value = obj.value + this.mDateFormat.toLowerCase().charAt(7);
      }
      if (lPos == 6) {
        if (obj.value.length == 2)
          obj.value = obj.value + this.mDateFormat.toLowerCase().charAt(2);
        else if (obj.value.length == 5)
          obj.value = obj.value + this.mDateFormat.toLowerCase().charAt(5);
      }
      this.MascaraInteiro(evt);
    }
    if (evt.keyCode == 13 && obj.value.length > 2 && obj.value.length < 10) {
      //Confirma configuraï¿½ï¿½o
      this.executeProgram();
      return;
    }
  }
}
